import React from 'react';
import classNames from 'classnames';

import styles from './list.less';

module.exports = React.createClass({
  displayName: 'List',
  getDefaultProps() {
    return {
      values: [],
      isMultiple: false,
      onChange: () => {}
    };
  },
  propTypes: {
    className: React.PropTypes.string,
    values: React.PropTypes.array.isRequired,
    isMultiple: React.PropTypes.bool,
    onChange: React.PropTypes.func.isRequired
  },
  getItems() {
    return this.props.children
        .filter(React.isValidElement)
        .filter(child => child.type.displayName == 'ListItem')
        .map((item, key) => React.cloneElement(item, {
          key: key,
          active: this.isItemActive(item.props),
          onClick: this.handleItemClick
        }));
  },
  isItemActive(itemProps) {
    return !itemProps.disabled && this.getValueIndex(itemProps.value) != -1;
  },
  getValueIndex(value) {
    return this.props.values.indexOf(value);
  },
  handleItemClick(value) {
    if (!this.props.isMultiple) {
      this.setSingleValues(value);
    } else {
      this.setMultipleValues(value);
    }
  },
  setSingleValues(value) {
    this.props.onChange([value]);
  },
  setMultipleValues(value) {
    var index = this.getValueIndex(value);

    var values = this.props.values.slice();
    if (index == -1) {
      values.push(value);
    } else {
      values.splice(index, 1);
    }

    this.props.onChange(values);
  },
  getClass() {
    console.log('styles.list', styles.list);
    return classNames(this.props.className, styles.list);
  },
  render() {
    return <ul className={this.getClass()}>
      {this.getItems()}
    </ul>
  }
});



/** WEBPACK FOOTER **
 ** ./src/lists/list/index.js
 **/